// extracted by mini-css-extract-plugin
export default {"producebasket":"producebasket_f858f09b26ef8028661f"};